import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';

import useService from './useService';

export const FETCH_USER_STATUS = {
	PENDING: 'pending',
	SUCCESS: 'success',
	ERROR: 'error',
	NOT_STARTED: 'notStarted'
};

export type FetchUserStatus = typeof FETCH_USER_STATUS[keyof typeof FETCH_USER_STATUS];

const useUserProfile = () => {
	const [fetchUserStatus, setFetchUserStatus] = useState<FetchUserStatus>(FETCH_USER_STATUS.NOT_STARTED);
	const history = useHistory();
	const { userSearchDetails, selectedUser, handleParseUserDetails, setSelectedUser } = useContext(UserDetailsContext);
	const { getUserData } = useService();
	const queryParams = _get(history, ['location', 'search']);
	const { showAlert } = useContext(AppContext);

	useEffect(() => {
		const fetchUserDetails = async () => {
			if (fetchUserStatus === FETCH_USER_STATUS.NOT_STARTED) {
				if (_isNil(selectedUser) || _isEmpty(selectedUser)) {
					setFetchUserStatus(FETCH_USER_STATUS.PENDING);
					const { selectionType, selectedValue } =
						!_isNil(userSearchDetails) && !_isEmpty(userSearchDetails) ? userSearchDetails : handleParseUserDetails();
					if (!_isNil(selectionType) && !_isNil(selectedValue)) {
						try {
							setSelectedUser(await getUserData(selectionType, selectedValue));
							setFetchUserStatus(FETCH_USER_STATUS.SUCCESS);
						} catch (error: any) {
							showAlert(error.error || 'User not found', { type: 'error' });
							setFetchUserStatus(FETCH_USER_STATUS.ERROR);
						}
					} else {
						history.push('/userProfile/selectUser');
						setFetchUserStatus(FETCH_USER_STATUS.SUCCESS);
					}
				} else {
					setFetchUserStatus(FETCH_USER_STATUS.SUCCESS);
				}
			} else if (fetchUserStatus === FETCH_USER_STATUS.NOT_STARTED) {
				setFetchUserStatus(FETCH_USER_STATUS.SUCCESS);
			}
		};

		fetchUserDetails();
	});

	return { userSearchDetails, fetchUserStatus, queryParams };
};

export default useUserProfile;
